import { render, staticRenderFns } from "./formsettingadd.vue?vue&type=template&id=49ee41b5&scoped=true"
import script from "./formsettingadd.vue?vue&type=script&lang=js"
export * from "./formsettingadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ee41b5",
  null
  
)

export default component.exports